import { i18n } from 'i18next'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { PlayStationAuthCallback, XboxAuthCallback } from '../auth'
import { DwemerBootsFooterLangListener, LanguagePath } from '../language'
import LogoutPage from '../pages/LogoutPage'
import NotFoundPage from '../pages/NotFoundPage.tsx'
import ApproverRouter from './ApproverRouter.tsx'
import UserRouter from './UserRouter'

interface RouterProps {
  dwemerBootsI18n: i18n
}

const ParentalConsentRouter = ({ dwemerBootsI18n }: RouterProps) => {
  return (
    <BrowserRouter>
      <DwemerBootsFooterLangListener dwemerBootsI18n={dwemerBootsI18n} />
      <Routes>
        <Route path="/:lang?" element={<LanguagePath />}>
          <Route path="" element={<UserRouter />} />

          <Route path="auth/callback">
            <Route path="xbox" element={<XboxAuthCallback />} />
            <Route path="psn" element={<PlayStationAuthCallback />} />
          </Route>

          <Route path="approve" element={<ApproverRouter />} />

          <Route path="logout" element={<LogoutPage />} />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
        {/* Send users to 404 page if route isn't defined */}
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default ParentalConsentRouter
